import { v4 as uuidv4 } from "uuid";

//
import IMG1 from "../images/reviewer-1.jpg";
import IMG2 from "../images/reviewer-2.jpg";
import IMG3 from "../images/reviewer-3.png";

const list = [
  {
    id: uuidv4(),
    title: "Change for the world!",
    text: "« They fit me in right away and got my injury addressed and on the road to recovery! »",
    name: "Kristen L.",
    img: IMG1,
    reviewPlace: "Google Reviewer",
  },
  {
    id: uuidv4(),
    title: "Very professional eye exam",
    text: "« The staff and doctors are friendly and knowledgeable they want you to be as healthy and comfortable »",
    name: "Kate A.",
    img: IMG3,
    reviewPlace: "Google Reviewer",
  },
  {
    id: uuidv4(),
    title: "Impressive Technology",
    text: "« The staff was very friendly and the doctor made it very easy to understand the results »",
    name: "Scott L.",
    img: IMG2,
    reviewPlace: "Google Reviewer",
  },
  {
    id: uuidv4(),
    title: "Great experience",
    text: "« I had a great experience with the doctor and staff. They were very professional and friendly »",
    name: "John D.",
    img: IMG1,
    reviewPlace: "Google Reviewer",
  },
  {
    id: uuidv4(),
    title: "Great experience",
    text: "« I had a great experience with the doctor and staff. They were very professional and friendly »",
    name: "John D.",
    img: IMG1,
    reviewPlace: "Google Reviewer",
  },
  {
    id: uuidv4(),
    title: "Great experience",
    text: "« I had a great experience with the doctor and staff. They were very professional and friendly »",
    name: "John D.",
    img: IMG1,
    reviewPlace: "Google Reviewer",
  },
  {
    id: uuidv4(),
    title: "Great experience",
    text: "« I had a great experience with the doctor and staff. They were very professional and friendly »",
    name: "John D.",
    img: IMG1,
    reviewPlace: "Google Reviewer",
  },
  {
    id: uuidv4(),
    title: "Great experience",
    text: "« I had a great experience with the doctor and staff. They were very professional and friendly »",
    name: "John D.",
    img: IMG1,
    reviewPlace: "Google Reviewer",
  },
  {
    id: uuidv4(),
    title: "Great experience",
    text: "« I had a great experience with the doctor and staff. They were very professional and friendly »",
    name: "John D.",
    img: IMG1,
    reviewPlace: "Google Reviewer",
  },
  {
    id: uuidv4(),
    title: "Great experience",
    text: "« I had a great experience with the doctor and staff. They were very professional and friendly »",
    name: "John D.",
    img: IMG1,
    reviewPlace: "Google Reviewer",
  },
];

export default list;
